<template>
  <basic-selects
    :hasSequence="hasSequence"
    :trigger="trigger"
    :isMultiple="isMultiple"
    :columns="columns"
    :items="onlineOrderModifierGroups"
    :title="`${$t('title.selecttaste')}`"
    idProperty="OnlineOrderModifierGroupId"
    nameProperty="OnlineOrderModifierGroupName"
    allSelectId="onlineOrderModifierGroupAllSelectBox"
    @onSaved="onSaved"
    :id="id"
    :pagination="pagination"
    @getItems="getItems"
    sortBy="OnlineOrderModifierGroupNumber"
    :defaultItems="defaultItems"
    viewName="OnlineOrderModifierGroupSelects"
  ></basic-selects>
</template>

<script>
import basicSelects from "./BasicSelects";

export default {
  data() {
    return {
      onlineOrderModifierGroups: [],
      columns: [
        {
          name: "OnlineOrderModifierGroupName",
        },
      ],
      id: "onlineOrderModifierGroupSelectModal",
      pagination: {},
    };
  },
  props: {
    trigger: false,
    isMultiple: false,
    modalId: undefined,
    defaultItems: undefined,
    onlineOrderType: undefined,
    hasSequence: false,
  },
  watch: {
    modalId: {
      handler(value) {
        if (value) this.id = value;
      },
      immediate: true,
    },
    trigger() {
      this.getItems();
    },
  },
  components: {
    basicSelects,
  },
  methods: {
    onSaved(item) {
      this.$emit("onSaved", item);
    },
    getItems(dTO) {
      if (!this.onlineOrderType) {
        this.$func.message.alert("系統異常 !");
        return;
      }
      if (!dTO) {
        dTO = {};
      }
      dTO.type = this.onlineOrderType;
      const vm = this;
      this.$api.onlineOrderModifierGroups.getPages(dTO).then((data) => {
        vm.onlineOrderModifierGroups = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
